import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_ARTICLE_LIST,
    getArticleListFail,
    getArticleListSuccess
} from '../action/getArticleListAction'

// api 
import getArticleListApi from '../api/getArticleListApi'

export function* getArticleListSaga(action) {
    try {
        const response = yield call(() => getArticleListApi(action.params))
        if (response.data.status === 1) {
            yield put(getArticleListSuccess(response, action))
        } else {
            yield put(getArticleListFail(response, action))
        }
    }
    catch (e) {
        yield put(getArticleListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_ARTICLE_LIST, getArticleListSaga)
}